var map = {
	"./black-bottle.png": "a98b",
	"./black-card.png": "5e15",
	"./black-virus.png": "8752",
	"./blue-bottle.png": "bb3b",
	"./blue-card.png": "aa98",
	"./blue-virus.png": "7d6e",
	"./blue.png": "64ed",
	"./cube.png": "b8b2",
	"./green.png": "9a4e",
	"./infection-rate.png": "d29f",
	"./logo.png": "cf05",
	"./map.png": "8b55",
	"./orange-card.png": "4293",
	"./outbreak-indicator.png": "09cb",
	"./outbreaks.png": "2aaa",
	"./pill-bottle.png": "c95b",
	"./rate-indicator.png": "734b",
	"./red-bottle.png": "d98a",
	"./red-card.png": "db1f",
	"./red-virus.png": "66ae",
	"./red.png": "d970",
	"./skull.png": "d17a",
	"./yellow-bottle.png": "51df",
	"./yellow-card.png": "a3dc",
	"./yellow-virus.png": "a89c",
	"./yellow.png": "13c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";